export const baseEventFragmentPayload = {
  event_version: '1.0.0',
  event_type: 'Interaction',
  event_category: 'products',
};

export const baseExperienceFragmentPayload = {
  page_name: 'affiliate-hub',
  app_name: 'eg-affiliate-products',
  app_version: '1.0.0',
};
